import { inject, Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { KeyValue } from '../models';
import { Repository } from '../database/repository';

@Injectable({
  providedIn: 'root',
})
export class KVRepository extends Repository<KeyValue, 'key'> {

  constructor() {
    const db = inject(NgxIndexedDBService);

    super(db, 'keyValue', 'key');
  }

}
